// @react-functional

import React from 'react';
import { useModal } from './useModal';
import { RestrictedModal } from './components/modal-restricted/RestrictedModal';

export const useRestrictedModal = () => {
  const { openModal } = useModal<{ source: string }>(
    ({ customProps, ...modalProps }) => (
      <RestrictedModal source={customProps.source} {...modalProps} />
    ),
  );
  return { openRestrictedModal: openModal };
};
